import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FD7F7486-1E30-44A5-A4B2-C908372835CD
 * name battery-charging-medium
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-charging-medium.svg
 * tags
 * - Battery 
 */
export const BatteryChargingMediumIcon = createSvgIcon(<><path d="M12 20H4V6H12M12.67 4H11V2H5V4H3.33C2.6 4 2 4.6 2 5.33V20.67C2 21.4 2.6 22 3.33 22H12.67C13.41 22 14 21.41 14 20.67V5.33C14 4.6 13.4 4 12.67 4M11 16H5V19H11V16M11 11.5H5V14.5H11V11.5M23 10H20V3L15 13H18V21" /></>, 'BatteryChargingMediumIcon');
export default BatteryChargingMediumIcon